/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Info_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"Shipping_viewer">;
    readonly " $refType": "Info_viewer";
};
export type Info_viewer$data = Info_viewer;
export type Info_viewer$key = {
    readonly " $data"?: Info_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Info_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Info_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchRegionalInfo",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "userZipCode",
      "type": "String",
      "defaultValue": "0"
    },
    {
      "kind": "LocalArgument",
      "name": "userCountryCode",
      "type": "String",
      "defaultValue": ""
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Shipping_viewer",
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ]
    }
  ]
};
(node as any).hash = '7125030509d076d6fe59d1160828a5d6';
export default node;
